import React, { useContext } from "react";
import { ProduitInterface } from "dataProvider/Produit";
import { IntlContext } from "context";

export interface LabelLogosProps {
    produit: ProduitInterface | any;
}

const LabelLogos: React.FC<LabelLogosProps> = ({ produit }) => {
    const intl = useContext(IntlContext);

    if (!(produit?.produit_labels || []).length) {
        return null;
    }

    const labels = (produit?.produit_labels || []).reduce((memo: any, label: HashMap<any>, index: number) => {
        if ((label?.label_libel || "").length) {
            memo.push(<p key={index}>{label?.label_libel}</p>);
        }
        return memo;
    }, []);

    return (
        <div className="product-informations__block">
            <h2 className="information__title">{intl.formatMessage("produit.fiche.label.labels_et_logos")}</h2>
            {labels}
        </div>
    );
};

export default LabelLogos;
